import React, { useState } from "react";
import { Button } from "@material-ui/core";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import Switch from "@mui/material/Switch";
import { moduleURL } from "../../../http/config";
import { requests } from "../../../requests";
import FormControlLabel from "@mui/material/FormControlLabel";
import { Backdrop } from "@material-ui/core";
// import { StyledCircularProgress } from "../../../styles/StyledComponents";
import { StopScroll } from "../../../Regex";
import {
  CssKeyboardDatePicker,
  CssTextField,
  CssTextField95,
  HeadingLine,
  StyledButton,
  StyledCircularProgress,
} from "../../../styles/StyledComponents";
export const labelText = (msg, not_required) => {
  return (
    <div
      style={{
        fontSize: "0.85rem",
        color: "rgb(76, 89, 103)",
        fontWeight: 500,
        margin: "0 0 5px 0",
      }}>{`${msg} ${not_required === true ? "" : "*"}`}</div>
  );
};
const classes = {
  container: {
    width: "100%",
    height: "auto",
  },
  form: {
    display: "flex",
    width: "100%",
    flexDirection: "column",
    paddingTop: "15px",
  },
  formGroup: {
    display: "flex",
    width: "100%",
    justifyContent: "space-between",
    alignItems: "center",
    margin: "15px 0",
  },
  CssTextField: {
    width: "40%",
  },
  formActions: {
    display: "flex",
    width: "100%",
    justifyContent: "space-between",
    alignItems: "center",
    margin: "15px 0",
  },
};

const NewForm = ({ closePopup, getFn }) => {
  const [fieldValues, setFieldValues] = useState({
    hsnCodeInput: "",
    statusInput: true,
  });

  const [isValid, setIsValid] = useState({
    hsnCodeInput: true,
  });
  const [error, setError] = useState("");
  const [pushNotier, setPushNotier] = useState(false);
  const [pushNoti, setPushNoti] = useState(false);
  const [loading, setLoading] = useState(false);

  const addNewHandler = (e) => {
    e.preventDefault();
    if (fieldValues.hsnCodeInput.length === 0) {
      setIsValid((prev) => ({ ...prev, hsnCodeInput: false }));
    }
    if (fieldValues.hsnCodeInput.length > 0) {
      setLoading(true);

      const postURL = moduleURL("masters/hsn/list");
      requests({
        method: "post",
        url: postURL,
        data: {
          hsn_code: fieldValues.hsnCodeInput,
          is_active: fieldValues.statusInput,
          // created_by: 0,
          // modified_by: 0,
        },
      }).then((res) => {
        if (res.error) {
         
          setError(res.data[0].message[0]);
          
          setPushNotier(true);
        } else {
          getFn();
          setError("");
          setPushNoti(true);
        }
      });
    }
  };
  const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });

  return (
    <div style={classes.container}>
      <form style={classes.form} onSubmit={addNewHandler}>
        <div style={classes.formGroup}>
        <div
                style={{
                  width: "100%",
                  marginTop: "10px",
                }}>
        {labelText("HSN Code")}
          <CssTextField
            type="number"
            onFocus={StopScroll}
            style={classes.CssTextField}
            onKeyDown={(evt) => {
              evt.key === "." && evt.preventDefault();

              evt.key === "e" && evt.preventDefault();

              evt.key === "E" && evt.preventDefault();
              evt.key === "-" && evt.preventDefault();
              evt.keyCode === 38 && evt.preventDefault();
              evt.keyCode === 40 && evt.preventDefault();
            }}
            variant="outlined"
            // label="HSN Code *"
            value={fieldValues.hsnCodeInput}
            onChange={({ target }) => {
              if (target.length !== 0) {
                setIsValid((prev) => ({ ...prev, hsnCodeInput: true }));
              }
              setFieldValues((prev) => ({
                ...prev,
                hsnCodeInput: target.value,
              }));
            }}
            onInput={(e) => {
              e.target.value = Math.max(0, parseInt(e.target.value))
                .toString()
                .slice(0, 9);
            }}
            error={!isValid.hsnCodeInput}
            helperText={isValid.hsnCodeInput ? "" : "Enter HSN Code"}
          />
          </div>
          {/* <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <p style={{ fontSize: "18px" }}>Active</p>
            <Switch
              // disabled
              defaultChecked
              onChange={(e) => {
                if (e.target.checked) {
                  setFieldValues((prev) => ({
                    ...prev,
                    statusInput: true,
                  }));
                } else {
                  setFieldValues((prev) => ({
                    ...prev,
                    statusInput: false,
                  }));
                }
              }}
            />
          </div> */}
        </div>
        <div style={classes.formActions}>
          <FormControlLabel
            control={
              <Switch
                disabled
                defaultChecked
                style={{ color: "#B0B0B0" }}
                onChange={(e) => {
                  if (e.target.checked) {
                    setFieldValues((prev) => ({
                      ...prev,
                      statusInput: true,
                    }));
                  } else {
                    setFieldValues((prev) => ({
                      ...prev,
                      statusInput: false,
                    }));
                  }
                }}
              />
            }
            label={fieldValues.statusInput ? "Active" : "Inactive"}
          />

          <Button
            type="submit"
            variant="contained"
            style={{
              backgroundColor: "rgb(241 154 48)",
              color: "white",
              textTransform: "capitalize",
            }}
          >
            Add
          </Button>
        </div>
      </form>
      {loading ? (
        <Backdrop
          style={{ zIndex: 1, color: "#fff", position: "absolute" }}
          open={loading}
        >
          <StyledCircularProgress color="rgb(30, 53, 89)" />
        </Backdrop>
      ) : (
        ""
      )}
      <Snackbar
        open={pushNoti}
        style={{}}
        anchorOrigin={{
          horizontal: "right",
          vertical: "bottom",
        }}
        severity="success"
        autoHideDuration={2000}
        onClose={() => {
          setPushNoti(false);
          setLoading(false);

          closePopup();
        }}
      >
        <Alert style={{ backgroundColor: "rgb(241 154 48)" }}>
          New HSN Code Added!
        </Alert>
        {/* message="Changes have been saved!" */}
      </Snackbar>
      <Snackbar
        open={pushNotier}
        style={{}}
        anchorOrigin={{
          horizontal: "right",
          vertical: "bottom",
        }}
        severity="error"
        autoHideDuration={5000}
        onClose={() => {
          // setOpenPopup(false);
          setPushNotier(false);
          setLoading(false);
          setError("");
          // closePopup();
        }}
      >
        <Alert severity="error">{error}</Alert>
        {/* message="Changes have been saved!" */}
      </Snackbar>
    </div>
  );
};

export default NewForm;
